import React from 'react'
import parse from 'html-react-parser'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import Fade from 'react-reveal/Fade'
import { ApplyNow } from './icons'

const ImageBlock = ({image, mobileImage, video, mobileVideo, caption, alignment, applyNow, removePadding = false}) => {

  const handleClick = () => {
    // smooth scroll to #apply
    const apply = document.getElementById('apply')
    apply.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <section className={`image-block image-block--${alignment} ${applyNow ? ' image-block--careers' : ''} ${removePadding ? 'image-block--no-padding' : ''}`}>
      { applyNow && <button onClick={handleClick} className='image-block__anchor'><ApplyNow /></button> }
      { image && 
        <div className="image-block__inner">
          <div className='image-block__wrapper' data-sal='slide-up' data-sal-duration='1000' data-sal-delay='0' data-sal-easing='ease'>
            { video && <video className='image-block__video image-block__video--desktop' autoPlay loop muted playsInline src={video} />}
            { mobileVideo && <video className='image-block__video image-block__video--mobile' autoPlay loop muted playsInline src={mobileVideo} />}
            { image?.localFile.childImageSharp && !video && <GatsbyImage className='desktop' image={getImage(image.localFile)} alt={image.altText ? image.altText : 'Atollon'} /> }
            { !image?.localFile.childImageSharp && !video && <img src={image.localFile.publicURL} alt={image.altText ? image.altText : 'Atollon'} />}
            { (mobileImage?.localFile || image?.localFile) && !video && <GatsbyImage className='mobile' image={getImage(mobileImage?.localFile ? mobileImage?.localFile : image?.localFile)} alt={mobileImage?.altText ? mobileImage?.altText : 'Atollon'} /> }
            { caption && <div className='image-block__caption'>{parse(caption)}</div> }
          </div>
        </div>
      }
    </section>
  );
};

export default ImageBlock